import React from "react";
import Context from "../../../../context";
import dictionary from "../../../../dictionary";

import {
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../components";
import { useTranslation } from "react-i18next";

const ParentInformation = () => {
  const { showModal, setShowModal, selectedParent } = React.useContext(
    Context.ParentScreen
  );

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"30vw"}
        maxWidth={"40vw"}
        open={showModal === "SHOW_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedParent?.avatar}
            name={
              selectedParent?.firstName
                ? selectedParent?.firstName
                : selectedParent?.name
            }
            lastName={selectedParent?.lastName ? selectedParent?.lastName : ""}
            phoneNumber={
              selectedParent?.phoneNumber
                ? selectedParent?.phoneNumber
                : selectedParent?.telephone
            }
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedParent?.gender && (
              <CustomView.Column
                medium={5}
                small={12}
                large={8}
                className="form-values form-column"
              >
                <label className="form-label">{t("gender")}</label>
                <p>
                  {dictionary.genderEnglish2Persian(selectedParent?.gender)}
                </p>
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default ParentInformation;
